import React from 'react';
import { NewCarouselContextProps } from './types';

const NewCarouselContext = React.createContext({} as NewCarouselContextProps);

export default NewCarouselContext;
